<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {Table} from 'sveltestrap'
    import {getAllEmailTemplate} from 'src/components/cabinet/#services/getAllEmailTemplate'
    import Modal from 'src/components/#common/modal/Modal.svelte'
    import {deleteEmailTemplate} from '../#services/emailTemplate'
    import {doShow as showAlert} from '../../#common/alert/store'
    import IconifyIcon from '@iconify/svelte'
    import editIcon from '@iconify/icons-fa-solid/edit'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'

    let deleteModalOpen = false
    let selectedKey

    getAllEmailTemplate.send()

    async function deleteTemplate(key) {
        try {
            await deleteEmailTemplate.request({ data: {key: key} })

            deleteModalOpen = false

            showAlert.set({
                status: 'success',
                text: 'Mail template successfully deleted!'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            getAllEmailTemplate.reset()
            getAllEmailTemplate.send()
        }
    }
</script>

<svelte:head>
    <title>Emails</title>
</svelte:head>

<MainLayout title="Emails">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="emails/add" class="btn btn-success mb-3">Create template</Link>
                <div class="emails-list">
                    <Table bordered responsive>
                        <thead>
                        <tr>
                            <td>Title</td>
                            <td class="text-center">Actions</td>
                        </tr>
                        </thead>
                        <tbody>
                        {#if $getAllEmailTemplate.loading}
                            <tr>
                                <td colspan="2">Loading...</td>
                            </tr>
                        {:else if !$getAllEmailTemplate.hasValue && $getAllEmailTemplate.error}
                            <tr>
                                <td colspan="2">Something went wrong.</td>
                            </tr>
                        {:else if $getAllEmailTemplate.hasValue}
                            {#each $getAllEmailTemplate.value as { key, mailTemplate, name}}
                                <tr>
                                    <td>{name}</td>
                                    <td>
                                        <Link to="emails/edit/{key}" class="btn btn-primary" title="Edit">
                                            <IconifyIcon icon={editIcon}/>
                                        </Link>
                                        <button class="btn btn-danger" title="Delete"
                                            on:click={() => { deleteModalOpen = true; selectedKey = key }}>
                                            <IconifyIcon icon={deleteIcon}/>
                                        </button>
                                    </td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
        <Modal bind:visible={deleteModalOpen} size="sm">
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Delete template</div>
                <div class="modal-custom__text">Do you really want to delete the template?</div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { deleteModalOpen = false }}>Close</button>
                    <button class="btn btn-primary" on:click={() => deleteTemplate(selectedKey)}>Yes</button>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    .emails-list :global(table) {
        width: auto;
    }

    .emails-list :global(tbody td) {
        vertical-align: middle;
        padding: 5px 10px;
        line-height: normal;
    }

    @media (max-width: 767px) {
        .emails-list td :global(.btn.btn-primary) {
            width: 38px;
            height: 38px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 5px;
            float: left;
            margin-right: 10px;
        }

        .btn-danger {
            width: 38px;
            height: 38px;
            padding: 0 !important;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 5px;
        }

        .emails-list :global(table) {
            width: 100%;
        }
    }
</style>
